import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

import { FormTextField, FormDateField, FormSwitchField } from '_components/_core';

function EventDetails({
  values,
  setFieldValue,
  errors,
  touched,
  handleChange,
  handleBlur,
}) {
  return (
    <Form className="mr-3 mt-3 ml-3">
      <Form.Row>
        <Form.Group as={Col} xl="12">
          <Form.Label>Nome do Evento</Form.Label>
          <FormTextField
            name="name"
            placeholder="Digite o nome do evento"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.name && errors.name}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} xl="12">
          <Form.Label>Endereço</Form.Label>
          <FormTextField
            name="address"
            placeholder="Local do evento"
            value={values.address}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.address && errors.address}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} md={6}>
          <Form.Label>Data de Início</Form.Label>
          <FormDateField
            name="start_date"
            placeholder="Data de início"
            value={values.start_date}
            onChange={date => setFieldValue('start_date', date)}
            error={touched.start_date && errors.start_date}
          />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>Data de Término</Form.Label>
          <FormDateField
            name="end_date"
            placeholder="Data de término"
            value={values.end_date}
            onChange={date => setFieldValue('end_date', date)}
            error={touched.end_date && errors.end_date}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} md={6}>
          <Form.Label>Capacidade</Form.Label>
          <FormTextField
            name="capacity"
            type="number"
            min="1"
            value={values.capacity}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.capacity && errors.capacity}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} className="d-flex align-items-end">
          <FormSwitchField
            label="Habilitar lista de espera quando cheio"
            name="waiting_list_enabled"
            checked={values.waiting_list_enabled}
            onChange={e => setFieldValue('waiting_list_enabled', e.target.checked)}
          />
        </Form.Group>
      </Form.Row>
    </Form>
  );
}

EventDetails.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};

export default EventDetails;
